import React from 'react'

import { Form, Col } from '_zari/core'

import { TiposTablaPersonalizadaConstant } from 'constants/index'

import * as TablaPersonalizadaService from 'services/tablasPersonalizadas.service'

const ListaPrecioFormGroup = ({ fIsSubmitting, idListaPrecio, setIdListaPrecio, flagEdicion }) => {
  const [listasPrecio, setListasPrecio] = React.useState([])

  React.useEffect(() => {
    TablaPersonalizadaService.getAsSelect(TiposTablaPersonalizadaConstant.LISTAPRECIO).then(({ data }) => {
      setListasPrecio(data)
      if (data && !flagEdicion) {
        setIdListaPrecio(data[0]._id)
      }
    })
  }, [setIdListaPrecio, flagEdicion])

  return (
    <Form.Group>
      <Form.Label text='LISTA' htmlFor='select-idListaPrecio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.Select
          id='select-idListaPrecio'
          name='select-idListaPrecio'
          disabled={fIsSubmitting}
          value={idListaPrecio}
          onChange={e => setIdListaPrecio(e.target.value)}
        >
          <option value=''>Seleccionar</option>
          {listasPrecio.map((val, key) => (
            <option key={key} value={val._id}>
              {val.nombre}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(ListaPrecioFormGroup)
